import {useEffect} from 'react'
import {useCustomPreferenceMarketless} from './use-custom-preference'
import {useLocaleCountry} from './use-locale-custom'

export const useWazzup = () => {
    const country = useLocaleCountry()
    const wazzupConfiguration = useCustomPreferenceMarketless('wazzupConfiguration')
    const config = wazzupConfiguration?.[country?.toLowerCase()] ?? null

    useEffect(() => {
        if (!config) return
        if (document.querySelector('script[src*="wazzup.me"]')) return
        const script = document.createElement('script')
        script.src = '//static.wazzup.me/libs/track.js'
        script.defer = true
        document.head.appendChild(script)
    }, [config])

    return config
}
